/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined) {
        "use strict";
        skyward.importingapproval = skyward.importingapproval || {};

        skyward.importingapproval.getConsentForRunImport = function ()
        {
            var buttonData = $(this).data();
            getRunImportConsent(buttonData.importid, buttonData.importid_securityhash);
        };

        skyward.importingapproval.detailsGetConsentForRunImport = function (importid, securityHash)
        {
            getRunImportConsent(importid, securityHash);
        };

        var getRunImportConsent = function (importID, securityHash)
        {
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForRunImport", importID, securityHash);
        };

        skyward.importingapproval.getConsentForScheduledImport = function ()
        {
            var buttonData = $(this).data();
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForScheduledImport", buttonData.importid, buttonData.importid_securityhash);
        };

        skyward.importingapproval.getConsentForDesignerDetails = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var rowNumber = button.closest(".browseRowOptions").data("row");

            makeAjaxCall("Skysys/UserImportApproval/GetConsentForDesignerDetails", buttonData.importid, buttonData.importid_securityhash, null, rowNumber);
        };

        skyward.importingapproval.getConsentForAddImport = function ()
        {
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForAddImport");
        };

        var consentAndRedirect = function ()
        {
            var buttonData = $(this).data();
            makeAjaxCall("SkySys/UserImportApproval/ApproveAndRedirect", buttonData.importid, buttonData.securityHash, buttonData.redirectAction);
        };

        var makeAjaxCall = function (url, importId, securityHash, redirectAction, rowNumber)
        {
            var postData =
            {
                importID: importId,
                securityHash: securityHash,
                redirectAction: redirectAction
            };

            $.ajax({
                url: skyward.global.virtualDir + url,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    handleAjaxResponse(data, importId, securityHash, rowNumber);
                }
            });
        };

        var handleAjaxResponse = function (data, importId, securityHash, rowNumber)
        {
            if (data.html)
            {
                var consentButton =
                {
                    text: "I Consent", click: consentAndRedirect, icon: "Check",
                    data:
                    {
                        "importid": importId,
                        "redirectAction": data.redirectAction,
                        "rowNumber": rowNumber,
                        "securityHash": securityHash
                    }
                };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                skyward.modalLayer.showCriticalDialog("IMPORT DESIGNER AGREEMENT", data.html, [consentButton, cancelButton], { width: 600, automationID: "import-consent-dialog" });
            }
            else
            {
                switch(data.redirectAction)
                {
                    case "RunImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/Import/RunImport', null, data.workflowData, null, null, null, false, null, null, null);
                        break;
                    case "DesignerDetails":
                        skyward.browse.primaryButtonClick('browse', rowNumber, 'full', 'SkySys', 'Import', 'DesignerDetails', importId, null, null, null, false);
                        break;
                    case "AddImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/Import/Add', null, null, null, null, null, false, null, null, null);
                        break;
                    case "CreateScheduledImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/ScheduledImport/Add', null, data.workflowData, null, null, null, false, null, null, null);
                        break;
                }
            }
        };

        var events =
        {
            'getConsentForRunImport': skyward.importingapproval.getConsentForRunImport,
            'getConsentForDesignerDetails': skyward.importingapproval.getConsentForDesignerDetails,
            'getConsentForAddImport': skyward.importingapproval.getConsentForAddImport,
            'getConsentForScheduledImport': skyward.importingapproval.getConsentForScheduledImport
        };

        skyward.events.registerEvents('importingapproval', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);